function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .st0 {\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "current",
  d: "M86,43.8c0,9-2.6,26.7-3,29.4h-12.9l1.6-2.7c5.6-1.5,10.6-9.7,10.2-13.8-.3-3.2-2.3-4-5.7-3.3-1.8-6.7-6.9-11.2-13.1-13.4-5.7-2-11-4.9-16.1-8.2-5.4,4.4-12.8,11-13,18.6v3c-2.3-.9-4.3,1-4.6,3.3-.4,3.7,3.4,12.4,9.5,13.8,0,0,1.3,2.1,1.5,2.7h-12.2c-.4-3.8-3.1-20.5-3-29.4.2-10.1,11.6-22.5,21.8-22.5h1.6c.8-2.1,2.4-3.3,4-4.2,16.4-6.2,33,11.4,33.3,26.7Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  fill: "current",
  d: "M66.8,83.1c-2.9,3.2-7,5.3-11.5,5.3s-7.8-2.4-10.6-5.3v.3c0,2-.5,5.3-1.3,7-2.2,5.7,25.8,5.7,24.5,0-.4-1.5-1.1-4.5-1.1-6.3v-1Z"
});

var SvgIcoSimulationCategoryFace = function SvgIcoSimulationCategoryFace(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 110 110",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcoSimulationCategoryFace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico_simulation_category_face.d3fd5d2f.svg";
export { ForwardRef as ReactComponent };